import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { firebase } from 'src/db/db';
import getNumberString from 'src/utils/getNumberString';

export default function PopupMusician({ className, open, setOpen, user, authSendNewMusicianApi, loading, setLoading, errorText, initialMusicianName, ...rest }) {
  const [musicianName, setMusicianName] = useState(initialMusicianName ? initialMusicianName : "");
  const [invocationErrorText, setInvocationErrorText] = useState();
  const navigate = useNavigate();

  const handleSave = async () => {
    // 1. Reveal Spinner.
    setLoading(true);

    // 2. TRIGGER NEW MUSICIAN API.
    await authSendNewMusicianApi(musicianName, user.email, user.uid);
  };

  const handleCancel = async () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        return navigate('/', {
          state: musicianName,
          replace: false
        });
      });
  };

  const handleMusicianNameChange = (e) => {
    const newMusicianName = e.target.value;
    const valueLength = newMusicianName.length;
    if (valueLength > 50) {
      setInvocationTooLong();
    } else if (!/\d/.test(newMusicianName) && !/[~`!@#$%^&*+=()\-[\]\\';,/{}|":<>?]/g.test(newMusicianName)) {
      setMusicianName(newMusicianName.toLowerCase());
      setInvocationErrorText(false);
    } else if (/\d/.test(newMusicianName)) {
      const numberString = getNumberString(newMusicianName.charAt(valueLength - 1));
      if (valueLength + numberString.length > 50) {
        setInvocationTooLong();
      } else {
        setMusicianName(newMusicianName.substring(0, valueLength - 1).toLowerCase() + (musicianName ? " " : "") + numberString)
        setInvocationErrorText(false);
      }
    } else {
      setInvocationErrorText(`Uh oh...  "${newMusicianName.charAt(valueLength - 1)}" and other special characters aren't allowed by Amazon Alexa. If you still want a special character, edit your Display Name on the profile page after setup. For now, try spelling your name with only letters.`);
    }
  };

  const setInvocationTooLong = () => {
    setInvocationErrorText(`Uh oh... name must be between 2 and 50 characters.`);
  }

  return (
    <div>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">What's Your Musician Name?</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            error={errorText ? !!errorText : !!invocationErrorText}
            helperText={errorText ? errorText : invocationErrorText}
            margin="dense"
            id="My Name"
            key="My Name"
            label="Musician Name"
            type="string"
            placeholder="Name"
            value={musicianName}
            fullWidth
            onChange={handleMusicianNameChange}
            onKeyPress={async (ev) => {
              if (ev.key === 'Enter') {
                ev.preventDefault();
                await handleSave();
              }
            }}
           />
        </DialogContent>
        { loading ? 
          <DialogActions>
            <CircularProgress />
          </DialogActions> :
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
                Cancel
            </Button>
          {musicianName 
            ? <Button onClick={async () => {await handleSave()}} color="primary">
                Create
              </Button>
            : ""
          }
          </DialogActions>
        }
        
      </Dialog>
    </div>
  );
}